export default __webpack_public_path__ + "static/media/logo.5360d117.png";